<template v-slot:body>
    <b-row v-if="loaded">
        <b-col lg="3" class="ml-4">
            <span class="text-dark">
                {{$t('sales_distribution_admin.year')}} : {{ yearNameById(dataArray.fiscal_year_id) }}
            </span>
        </b-col>
        <b-col lg="4">
            <span class="text-dark">
                {{$t('sales_distribution_admin.month')}} : {{ monthNameById(dataArray.month) }}
            </span>
        </b-col>
        <b-col lg="4">
            <span class="text-dark">
                {{ $t('production_store.target_date')}} : {{ dataArray.target_date | dateFormat }}
            </span>
        </b-col>
        <div class="mt-4 col-lg-12 col-sm-12 col-md-12">
            <b-col>
                <b-overlay>
                    <table class="table table-bordered">
                        <tr class="bg-light">
                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                            <th>{{ $t('sales_distribution_admin.sales_center') }}</th>
                            <th>{{ $t('production_store.pro_category') }}</th>
                            <th>{{ $t('sales_distribution_admin.target_amount') }}</th>
                            <th>{{ $t('production_store.recommend_quantity') }}</th>
                            <th colspan="2">{{ $t('sales_distribution_admin.remark') }}</th>
                            <!-- <th>{{ $t('sales_distribution_admin.remark_bn') }}</th> -->
                        </tr>
                        <tr v-for="(item, index) in dataArray.details" :key="index">
                            <td class="text-center">{{ $n(index + 1) }}</td>
                            <td class="text-center">{{ salesCenterNameById(item.sales_center_id) }}</td>
                            <td>{{ item.category_id ? getCategoryName(item.category_id) : '' }}</td>
                            <td class="text-center">{{ $n(item.target_amount)}}</td>
                            <td class="text-center">{{ $n(item.approve_amount)}}</td>
                            <td class="text-center" colspan="2">{{ ($i18n.locate === 'bn') ? item.remark_bn : item.remark }}</td>
                            <!-- <td>{{ item.remark }}</td>
                            <td>{{ item.remark_bn }}</td> -->
                        </tr>
                        <tr>
                            <td colspan="3" class="text-center">{{ $t('sales_distribution_admin.grand_total') }}</td>
                            <td colspan="1" class="text-center">{{ $n(dataArray.target_amount) }}</td>
                            <td colspan="2" class="text-left">{{ $t('sales_distribution_admin.recommend_total') + ' = ' + $n(dataArray.approve_amount) }}</td>
                            <!-- <td colspan="1"> {{ $t('sales_distribution_admin.recommend_total') }}</td> -->
                        </tr>
                    </table>
                </b-overlay>
            </b-col>
        </div>
    </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { salesTargetById } from '../../api/routes'

export default {
    props: ['id'],
    data () {
        return {
            dataArray: {
                details: []
            },
            sl: 0,
            loaded: false
        }
    },
    computed: {
        salesCenterList: function () {
            return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(year => year.status === 0)
        },
        currentLocale: function () {
            return this.$i18n.locale
        },
        monthList: function () {
          const montObj = this.productCommonObj.monthList
          return montObj.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
            } else {
              return { value: obj.value, text: obj.text_en }
            }
          })
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    created () {
        if (this.id) {
            this.getTargetInfoData(this.id)
        }
    },
    methods: {
        getCategoryName (Id) {
            const Obj = this.productCommonObj.productCategoryList.find(el => el.value === parseInt(Id))
            if (typeof Obj !== 'undefined') {
                return this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn
            }
            return ''
        },
        async getTargetInfoData (id) {
          const result = await RestApi.getData(productionServiceBaseUrl, salesTargetById + '/' + id)
          if (result.success) {
            this.loaded = true
            this.dataArray.details = result.data.sales_target_details
            this.dataArray.fiscal_year_id = result.data.fiscal_year_id
            this.dataArray.month = result.data.month
            this.dataArray.target_date = result.data.target_date
            this.dataArray.target_amount = result.data.target_amount
            this.dataArray.approve_amount = result.data.approve_amount
          }
        },
        salesCenterNameById (id) {
            const category = this.salesCenterList.find(center => center.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        yearNameById (id) {
            const product = this.fiscalYearList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text
            } else {
               return product.text
            }
        },
        monthNameById (monthId) {
            const id = parseInt(monthId)
            const unit = this.monthList.find(month => month.value === id)
            return unit.text
        }
    }
}
</script>
